import { render, staticRenderFns } from "./DialogSelectProduct.vue?vue&type=template&id=4d8ea3c4"
import script from "./DialogSelectProduct.vue?vue&type=script&setup=true&lang=js"
export * from "./DialogSelectProduct.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports